import {useLocation} from 'react-router'
import {match as routeMatch} from './routesUtils'

export interface CustomerFromRoute {
    rkId?: string
    customerId?: string
}

export const useCustomerFromRoute = (): CustomerFromRoute => {
    const {pathname} = useLocation()
    return routeMatch(pathname)
}
